import { observeElement } from '@uvocore-front/utils';
/* eslint-disable  no-new */
import '../../components/Header/main';
import '../../components/Footer';
import '../../components/Calculator/default';
import '../../components/PriceTable'; // eslint-disable-line
import Accordion from '../../components/Accordion';

window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.Accordion')) {
    observeElement({
      element: '.Accordion',
      marginValue: 400,
      callback: () => {
        new Accordion({
          itemsSelector: '.Accordion__item',
        });
      },
    });
  }
});
